module.exports = __webpack_public_path__ + "static/media/start-working.06941d61.png";